import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Card, CardActionArea, CardContent } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
import { getIconByName } from '../../../utils/iconMap';
const QuickActions = ({ label, gradient, heading, subheading, items = [], paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, fontFamily, fontWeight = 700, componentAlignment = 'center', }) => {
    const theme = useTheme();
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.light)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 6,
            paddingBottom: paddingBottom || 6,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 1100, mx: 'auto', px: 3 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, color: 'text.secondary', letterSpacing: 1.5 }, children: label })), heading && (_jsx(Typography, { variant: "h4", sx: {
                        fontWeight: Number(fontWeight) || 700,
                        mb: 1,
                        fontFamily: fontFamily || undefined,
                        color: 'text.primary',
                    }, children: heading })), subheading && (_jsx(Typography, { variant: "body1", sx: { color: 'text.secondary', mb: 4, maxWidth: 600, mx: 'auto' }, children: subheading })), _jsx(Box, { sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(2, 1fr)',
                            sm: 'repeat(3, 1fr)',
                            md: `repeat(${Math.min(items.length, 4)}, 1fr)`,
                        },
                        gap: 2.5,
                    }, children: items.map((item, index) => {
                        const IconComponent = getIconByName(item.icon || 'ArrowForward');
                        return (_jsx(Card, { sx: {
                                borderRadius: 2.5,
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: '0 2px 8px rgba(0,40,85,0.05)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    borderColor: theme.palette.primary.main,
                                    boxShadow: `0 8px 28px ${alpha(theme.palette.primary.main, 0.12)}`,
                                    transform: 'translateY(-6px)',
                                },
                            }, children: _jsx(CardActionArea, { href: item.href, sx: { height: '100%' }, children: _jsxs(CardContent, { sx: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        p: 3,
                                    }, children: [_jsx(Box, { sx: {
                                                width: 56,
                                                height: 56,
                                                borderRadius: 2,
                                                bgcolor: alpha(theme.palette.primary.main, 0.08),
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 2,
                                            }, children: _jsx(IconComponent, { sx: {
                                                    fontSize: 28,
                                                    color: theme.palette.primary.main,
                                                } }) }), _jsx(Typography, { variant: "subtitle1", sx: {
                                                fontWeight: 600,
                                                mb: 0.5,
                                                fontFamily: fontFamily || undefined,
                                                color: 'text.primary',
                                            }, children: item.title }), item.description && (_jsx(Typography, { variant: "body2", sx: { color: 'text.secondary', lineHeight: 1.5 }, children: item.description }))] }) }) }, index));
                    }) })] }) }));
};
export default QuickActions;
